<template>
  <div>
    <ClientBookingView v-if="$getConstRole('ROLE_CLIENT') == role"></ClientBookingView>
    <AgentBookingView v-if="$getConstRole('ROLE_AGENT') == role"></AgentBookingView>
    <AdminBookingView v-if="$getConstRole('ROLE_ADMIN') == role"></AdminBookingView>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import ClientBookingView from '@/views/client/booking/View.vue'
import AgentBookingView from '@/views/agent/booking/View.vue'
import AdminBookingView from '@/views/admin/booking/View.vue'

export default {
  name: 'BookingsCreateNew',
  data: () => ({
    role: 0
  }),
  computed: {
    ...mapGetters(['getCurrentUser']),
  },
  mounted () {
    this.role = this.getCurrentUser.role
  },
  methods: {
  },
  components: {
    AgentBookingView,
    ClientBookingView,
    AdminBookingView
  },
};
</script>
